module.exports = __webpack_public_path__ + "img/flag-GT.4e8ac132.png";